import { CSSProperties } from 'react'

export const viewportStyle: CSSProperties = {
  top: 0,
  position: 'absolute',
  height: '100%',
  width: '100%',
}
